import Joi from "joi-browser";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useMemo, useState } from "react";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import password from "V2.0/SignupnLogin/Validators/password";
import PasswordRules from "V2.0/components/PasswordRules";

const buildTemplate = (passwordValue: string) => [
  {
    name: "firstName",
    label: "First Name",
    type: "text",
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter a password",
    info: <PasswordRules value={passwordValue} />,
  },
];

const schema = {
  firstName: Joi.string().max(125).required().label("First Name"),
  lastName: Joi.string().max(125).required().label("Last Name"),
  email: Joi.string().email().required().label("email"),
  password: password.string().policy().required().label("password"),
};

export default function UserAdd(props) {
  const { onCreate } = props;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const inputField = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  };

  const { data, handleChange, validate, error } = useForm(
    inputField,
    schema,
    false
  );

  const template = useMemo(() => buildTemplate(data.password), [data.password]);

  const handleCreate = () => {
    const lifecycleCbs = {
      onInit: () => {
        setLoading(true);
        message.loading("Creating Account");
      },

      onSuccess: () => {
        setLoading(false);
        message.destroy();
        message.success("Account Created");
        setOpen(false);
      },

      onError: (e) => {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to create account");
      },
    };

    onCreate(data, lifecycleCbs);
  };

  // Validate the whole form, not just the fields the user has touched — an
  // untouched form has no entries in `error` yet, which would otherwise leave
  // Next enabled on an empty dialog.
  const isCreateDisabled = Boolean(validate(data, schema));

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
        }}
      >
        <PlusIcon /> Invite Team Member
      </Button>
      <Dialog size="md" open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Create Account</DialogTitle>
        <DialogBody>
          <Form
            data={data}
            template={template}
            error={error}
            handleChange={handleChange}
          />
        </DialogBody>
        <DialogActions>
          <Button outline onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleCreate}
            disabled={isCreateDisabled}
            loading={loading}
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
